


























const themeColorNames = [
  'primary',
  'secondary',
  'dark',
  'green',
  'error',
  'success',
  'warning',
  'grey-100',
  'grey-200',
  'grey-300',
  'grey-400',
  'white'
];

import Vue from 'vue';
export default Vue.extend({
  props: {
    type: {
      validator: (value: string) => {
        // The value must match one of these
        const valid = ['grow', 'spin'].indexOf(value) !== -1;
        if (!valid) console.error("Accepted types for AiForegroundLoader are 'grow' and'spin'");
        return valid;
      },
      default: 'grow'
    } as any,
    color: {
      type: String,
      default: 'primary'
    },
    opacity: {
      type: Number,
      default: 0.8
    },
    positionX: {
      type: String,
      default: 'center'
    },
    positionY: {
      type: String,
      default: 'center'
    },
    size: {
      type: String,
      default: '2rem'
    },
    loading: {
      type: Boolean,
      default: true
    },
    backdrop: {
      type: String,
      default: 'white'
    },
    text: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: 'inherit'
    },
    textPosition: {
      type: String,
      default: 'bottom'
    }
  },
  methods: {
    calcFlexPosition(position: string) {
      switch (position.toLowerCase()) {
        case 'left':
          return 'flex-start';
        case 'top':
          return 'flex-start';
        case 'right':
          return 'flex-end';
        case 'bottom':
          return 'flex-end';
        case 'center':
          return 'center';
        default:
          return;
      }
    }
  },
  computed: {
    getColor(): string {
      if (themeColorNames.includes(this.color)) {
        return `var(--v-${this.color}-base)`;
      }

      return this.color;
    },
    getBackdrop(): string {
      if (themeColorNames.includes(this.backdrop)) {
        return `var(--v-${this.backdrop}-base)`;
      }

      return this.backdrop;
    },
    getTextPosition(): string {
      switch (this.textPosition.toLowerCase()) {
        case 'left':
          return 'row-reverse';
        case 'top':
          return 'column-reverse';
        case 'right':
          return 'row';
        case 'bottom':
          return 'column';
        default:
          return '';
      }
    }
  },
  mounted() {
    const parentEl = this.$el.parentElement;
    if (parentEl) {
      parentEl.style.position = 'relative';
    }
  }
});
